<script>
import { defineComponent, h } from 'vue';
import Facebook from './channels/Facebook.vue';
import Website from './channels/Website.vue';
import Twitter from './channels/Twitter.vue';
import Api from './channels/Api.vue';
import Email from './channels/Email.vue';
import Sms from './channels/Sms.vue';
import Whatsapp from './channels/Whatsapp.vue';
import Line from './channels/Line.vue';
import Telegram from './channels/Telegram.vue';
import Gupshup from './channels/Gupshup.vue';
import Marcatel from './channels/Marcatel.vue';
import Whatsappweb from './channels/Whatsappweb.vue';
import MercadoLibre from './channels/MercadoLibre.vue';
import FacebookComments from './channels/FacebookComments.vue';

const channelViewList = {
  facebook: Facebook,
  website: Website,
  twitter: Twitter,
  api: Api,
  email: Email,
  sms: Sms,
  whatsapp: Whatsapp,
  line: Line,
  telegram: Telegram,
  gupshup: Gupshup,
  marcatel: Marcatel,
  whatsappweb: Whatsappweb,
  mercadolibre: MercadoLibre,
  facebookcomments: FacebookComments,
};

export default defineComponent({
  name: 'NewChannelView',
  props: {
    channelName: {
      type: String,
      required: true,
    },
  },
  render() {
    console.log(this.channelName);
    const ChannelComponent = channelViewList[this.channelName];
    return ChannelComponent ? h(ChannelComponent) : null;
  },
});
</script>
